import { useLocation } from "wouter";
import { Sidebar } from "./sidebar";
import { TopBar } from "./top-bar";
import { shellStore, useShell } from "@/lib/ui-shell-store";

/**
 * KABUK (TailAdmin AppLayout) — daraltılabilir sidebar + sticky header + kayan
 * içerik. Sidebar genişliğine göre içerik kenar boşluğu animasyonlu değişir;
 * mobilde çekmece + karartma. Cluster Maps tam-ekran tuvalini kullandığı için
 * orada header gizlenir.
 */
export function MainLayout({ children }: { children: React.ReactNode }) {
  const [location] = useLocation();
  const { expanded, hovered, mobileOpen } = useShell();
  const fullBleed = location.includes("/clusters");
  const wide = expanded || hovered;

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-950">
      <Sidebar />

      {/* Mobil çekmece karartması */}
      {mobileOpen && (
        <div onClick={() => shellStore.closeMobile()} className="fixed inset-0 z-40 bg-gray-900/50 lg:hidden" />
      )}

      <div className={`flex h-screen flex-col overflow-y-auto overflow-x-hidden transition-all duration-300 ease-in-out ${wide ? "lg:ml-[290px]" : "lg:ml-[90px]"}`}>
        {!fullBleed && <TopBar />}
        <div className={fullBleed ? "min-h-0 flex-1" : "flex-1"}>{children}</div>
      </div>
    </div>
  );
}
